import * as React from "react";
import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import {CircularProgress, Container, Typography } from "@mui/material";
import SingleBlogCard from "./SingleBlogCard";

const SingleBlog = () => {

  const { blogID } = useParams();
  const [singlebloglist, setSinglebloglist] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    fetch("https://tranquil-anchorage-09740.herokuapp.com/blogs")
      .then((response) => response.json())
      .then((data) => {
        // setsinglebloglist(data);
        // eslint-disable-next-line eqeqeq
        const singlebloglistId = data.find((blog) => blog._id == blogID);
        setSinglebloglist(singlebloglistId);
        setIsLoading(false);
      });
  }, [blogID]);


  return (
    <Container sx={{ border: 0, mt: 4 }} maxWidth="lg">
        {isLoading && <CircularProgress /> }
      <Grid container spacing={2} sx={{pt:7 }}>
        <Grid item xs={12} sm={12}>
          <Typography gutterBottom variant="h5" component="div">
            <SingleBlogCard isLoading={isLoading} key={singlebloglist?._id} singlebloglist={singlebloglist}></SingleBlogCard>
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SingleBlog;
